export default {"src":"/_next/static/media/bouncing-squares.d7179577.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};